
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-world-of-impact",
      function () {
        return require("private-next-pages/our-world-of-impact/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-world-of-impact"])
      });
    }
  